import { type CSSProperties } from "react";
import "./Separator.css";

export default function Separator({ style }: { style?: CSSProperties }) {
  return <div className="separator" style={style} data-testid="separator" />;
}
